import {
  APP_SETTING_REFRESH_PROJECT_BEGIN,
  APP_SETTING_REFRESH_PROJECT_SUCCESS,
  APP_SETTING_REFRESH_PROJECT_FAILURE,
  APP_SETTING_REFRESH_PROJECT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function refreshProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_REFRESH_PROJECT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/refresh-project`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_REFRESH_PROJECT_SUCCESS,
              data: res,
            });
            toast.success('Project Refreshed Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_REFRESH_PROJECT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_REFRESH_PROJECT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRefreshProjectError() {
  return {
    type: APP_SETTING_REFRESH_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_REFRESH_PROJECT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        refreshProjectPending: true,
        refreshProjectError: null,
      };

    case APP_SETTING_REFRESH_PROJECT_SUCCESS:
      // The request is success
      return {
        ...state,
        refreshProjectPending: false,
        refreshProjectError: null,
      };

    case APP_SETTING_REFRESH_PROJECT_FAILURE:
      // The request is failed
      return {
        ...state,
        refreshProjectPending: false,
        refreshProjectError: action.data.error,
      };

    case APP_SETTING_REFRESH_PROJECT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        refreshProjectError: null,
      };

    default:
      return state;
  }
}
